import type { RulesEntities } from '@jane/business-admin/types';

export interface BrandObj {
  name: string;
  product_brand_id: number;
}

/**
 * A special's `rules_entities` is a flat dictionary covering every brand the special
 * references — included and excluded alike, and across every section of a bundle — so
 * the brand ids held by one rule section are what decide which of those names belong
 * to that section.
 *
 * An id with no entry keeps its place rather than being dropped: the picker rebuilds
 * `brand_ids` from what it holds, so discarding an unrecognized id here would quietly
 * remove that brand from the special on the next save.
 */
export const toSelectedBrands = (
  brandIds: number[] | undefined,
  brands: RulesEntities['brands']
): BrandObj[] =>
  (brandIds ?? []).map((product_brand_id) => ({
    product_brand_id,
    name: brands?.[product_brand_id]?.name ?? `Brand ${product_brand_id}`,
  }));
